import {
  Button,
  Checkbox,
  Grid,
  InputAdornment,
  InputBase,
  List,
  ListItem,
  ListItemText,
  makeStyles,
  Menu,
} from '@material-ui/core';
import {
  Close as CloseIcon,
  FilterListRounded as FilterListRoundedIcon,
  Search as SearchIcon,
} from '@material-ui/icons';
import clsx from 'clsx';
import i18n from 'i18n';
import React from 'react';
import { Filter, SelectedFilter } from 'utils/filters';
import styles from './styles';

interface Props {
  filters: Filter[];
  selectedFilters: SelectedFilter[];
  onCheckFilter: (filter: Filter) => void;
}
const FilterableMenu = ({ filters, selectedFilters, onCheckFilter }: Props) => {
  const classes = makeStyles(styles)();

  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);
  const [search, setSearch] = React.useState('');

  const openMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const closeMenu = () => {
    setAnchorEl(null);
    setSearch('');
  };

  const filteredFilterOptions = filters.filter(option =>
    i18n
      .t(option.label)
      .toLowerCase()
      .includes(search.toLowerCase())
  );

  const handleCheckFilter = (filter: Filter) => {
    onCheckFilter(filter);
    closeMenu();
  };

  return (
    <Grid>
      <Button
        variant="outlined"
        startIcon={<FilterListRoundedIcon />}
        className={classes.filtersButton}
        onClick={openMenu}
      >
        {i18n.t('FILTERS_KEY')}
      </Button>

      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={closeMenu}>
        <Grid className={classes.searchItem}>
          <InputBase
            placeholder={i18n.t('SEARCH_FILTERS_KEY')}
            autoFocus
            fullWidth
            value={search}
            onKeyDown={e => {
              if (e.key === 'Tab') e.stopPropagation();
            }}
            onChange={e => setSearch(e.target.value)}
            startAdornment={
              <InputAdornment position="start">
                <SearchIcon className={classes.searchIcon} />
              </InputAdornment>
            }
            endAdornment={
              <InputAdornment position="end">
                <CloseIcon
                  onClick={() => setSearch('')}
                  className={clsx(classes.closeIcon, {
                    [classes.hideCloseIcon]: !search,
                  })}
                />
              </InputAdornment>
            }
          />
        </Grid>

        <List dense className={classes.listContainer}>
          {filteredFilterOptions.map(filter => (
            <ListItem
              key={filter.field}
              button
              onClick={() => handleCheckFilter(filter)}
              onKeyDown={e => {
                if (e.key === 'Tab') {
                  e.stopPropagation();
                }
              }}
            >
              <Checkbox
                edge="start"
                checked={
                  !!selectedFilters.some(item => item.field === filter.field)
                }
                tabIndex={-1}
              />
              <ListItemText primary={i18n.t(filter.label)} />
            </ListItem>
          ))}
        </List>
      </Menu>
    </Grid>
  );
};

export default FilterableMenu;
